import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserRoles = createSelector(
  [(store: RootState) => store.userShow.userRoles],
  (data) => data || []
);
